import {generateRouteTo} from 'epic-fortnite-react';
import {connectToStores} from 'epic-alt-utils';
import FriendInviteActions from 'epic-fortnite-react/actions/FriendInviteActions';
import LoginActions from 'epic-fortnite-react/actions/LoginActions';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import {LoginStore} from '../../stores';

@connectToStores
class FriendInvite extends React.Component {
  static propTypes = {
    loginStore: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    data: PropTypes.object,
  };

  static getStores() {
    return [LoginStore];
  }

  static getPropsFromStores() {
    return {
      loginStore: LoginStore.getState(),
    };
  }

  onSendInvite = () => {
    const {
      loginStore: {isLoggedIn},
      match: {
        params: {friendId, platform},
      },
      location,
    } = this.props;
    if (!isLoggedIn) {
      LoginActions.requestLoginModal({
        redirectUrl: `/friend/${encodeURIComponent(friendId)}${
          platform ? `/${encodeURIComponent(platform)}` : ''
        }?sendInvite=true`,
      });
    } else {
      FriendInviteActions.sendInvite({
        friendId,
        platform,
      });
      this.props.history.push(generateRouteTo('/download?friend=true', location));
    }
  };

  render() {
    const {data} = this.props;
    const stepData = data.steps || [];
    const steps = stepData.map((item, index) => {
      const id = index;
      return (
        <li key={`item-${id}`}>
          <h3>{item.title}</h3>
          <div dangerouslySetInnerHTML={{__html: item.description}} />
        </li>
      );
    });
    const heroStyle = {backgroundImage: `url(${data.heroes[0]})`} || {};
    return (
      <div className="container friend-invite-content">
        <div className="row">
          <div className="col-xs-12 text-center">
            <img src={data.logo} alt="fortnite" className="logo img-responsive" />
            <div className="header-text-container">
              <h2>{data.defaultMessage}</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text-center">
            <div className="steps-container">
              <h1>{data.getStarted}</h1>
              <ul className="steps">{steps}</ul>
              <button className="btn btn-display no-animate" onClick={this.onSendInvite}>
                <span>{data.cta}</span>
              </button>
            </div>
          </div>
        </div>
        <div className="heroes" style={heroStyle} />
      </div>
    );
  }
}

export default withRouter(FriendInvite);
